export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative px-6 md:px-12 py-10 border-t border-[#2E2A28] bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="w-2 h-2 rounded-full bg-[#C9A961]" />
          <span className="font-mono-detail text-[0.7rem] tracking-[0.28em] uppercase text-[#A19D9B]">
            Shadow / Operator — © {new Date().getFullYear()}
          </span>
        </div>
        <div className="font-mono-detail text-[0.65rem] tracking-[0.22em] uppercase text-[#A19D9B]">
          Built in silence. Run in the dark.
        </div>
      </div>
    </footer>
  );
}
